module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_iterators.js
// module id = ./node_modules/core-js/library/modules/_iterators.js
// module chunks = 1